import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Checkbox,
  Stack,
  InputAdornment,
} from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { SuppliesDetailObject } from "../../../../core/models/suppliesDetail/suppliesDetail.model";
import { useEffect, useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ChangeEventDatePicker } from "../../../../core/models/bills/bills.model";
import ButtonElement from "../../../UI/ButtonElement/ButtonElement";
import LoadingComponentComponent from "../../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { NewPowers } from "../../../../core/models/managementsUpdate/managementsUpdatePowers/managementsUpdatePowers";
import ManagementUploadFile from "../../../Managements/ManagementsUploadFile/ManagementsUploadFile";
import ManagementsCancelProcess from "../../../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import { formatUpdateGasFlowRequestBody } from "../../../../utils/components/managementsUpdate/managementsUpdateGasFlow/managementsUpdateGasFlow.util";
import theme from "../../../../muiTheme";

interface ManagementsUpdateNewGasFlowProps {
  cupsDetail: SuppliesDetailObject;
  isLoading: boolean;
  handleSubmit: (incidenceText: string) => void;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

const ManagementsUpdateNewGasFlow = ({
  cupsDetail: { powers, rate },
  isLoading,
  handleSubmit,
  setFile,
}: ManagementsUpdateNewGasFlowProps) => {
  const { t } = useTranslation();
  const [checkBoxRadioValue, setCheckBoxRadioValue] = useState<string>("");
  const [isConsentAccepted, setIsConsentAccepted] = useState<boolean>(false);
  const [newGasFlow, setNewGasFlow] = useState<{
    value: string;
    period: string;
  }>({ value: "", period: "" });
  const [isModalOpen, setModalOpen] = useState(false);
  const [appliedDay, setAppliedDay] = useState<ChangeEventDatePicker | null>(
    null
  );
  const [notes, setNotes] = useState<string>("");
  const isDisabled =
    !isConsentAccepted ||
    !!!checkBoxRadioValue.length ||
    !newGasFlow.value.length ||
    !newGasFlow.period.length;
  const flowActual = powers.length ? powers[0].hiredPower : [];
  const mesurement = ["RL. 1", "RL. 2", "RL. 3"].includes(rate) ? "kWh" : "gWh";

  useEffect(() => {
    if (rate) {
      setNewGasFlow((prevNewGasFlow) => ({
        ...prevNewGasFlow,
        period: rate,
      }));
    }
  }, [rate]);

  const appliedDayData = [
    {
      id: "asap",
      label: "Cuanto antes",
      value: "asap",
    },
    {
      id: "selectDate",
      label: "Seleccionar fecha",
      value: "selectDate",
    },
  ];

  const gasTypeData = [
    {
      id: "RL. 1",
      label: "RL. 1",
      value: "RL. 1",
    },
    {
      id: "RL. 2",
      label: "RL. 2",
      value: "RL. 2",
    },
    {
      id: "RL. 3",
      label: "RL. 3",
      value: "RL. 3",
    },
    {
      id: "RL. 4",
      label: "RL. 4",
      value: "RL. 4",
    },
    {
      id: "RL. TB5",
      label: "RL. TB5",
      value: "RL. TB5",
    },
    {
      id: "RL. TA5",
      label: "RL. TA5",
      value: "RL. TA5",
    },
    {
      id: "RL. 6",
      label: "RL. 6",
      value: "RL. 6",
    },
    {
      id: "RL. 7",
      label: "RL. 7",
      value: "RL. 7",
    },
  ];

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  return (
    <form>
      <Stack component="div">
        <Stack>
          <Typography
            component="h3"
            variant="h3"
            paddingBottom={{ xs: "1.25rem", md: "1rem" }}
          >
            {t("Gestiones.Elige el nuevo caudal diario (Qd)")}
          </Typography>
        </Stack>
        <Stack paddingBottom={{ xs: "2rem", md: "3.5rem" }}>
          <Typography component="p" variant="body1">
            {t("Gestiones.A continuación se indica la tarifa")}
          </Typography>
        </Stack>
        <Stack paddingBottom={{ xs: "2rem", md: "3.5rem" }}>
          <Typography component="h3" variant="h3" paddingBottom="1.5rem">
            {t("Gestiones.Nuevo caudal")}
          </Typography>
          <FormControl>
            <FormLabel style={{ paddingBottom: ".8rem" }}>
              <Typography fontWeight={600} fontSize={"1rem"} variant="button">
                {t(`Gestiones.Caudal actual`)}
              </Typography>
            </FormLabel>
            <Typography component="p" variant="body1" paddingBottom={"1.5rem"}>
              {flowActual} {mesurement}
            </Typography>
          </FormControl>
          <FormControl>
            <FormLabel style={{ paddingBottom: ".8rem" }}>
              <Typography fontWeight={600} fontSize={"1rem"} variant="button">
                {t(`Gestiones.Tarifas`)}
                <span style={{ color: "red" }}> *</span>
              </Typography>
            </FormLabel>
            <Box
              display={"flex"}
              flexWrap={"wrap"}
              gap={"1.5rem"}
              flexDirection={"row"}
              paddingBottom={"1.5rem"}
            >
              {gasTypeData.map(({ id, label, value }) => (
                <Box
                  key={id}
                  component={"div"}
                  display={"flex"}
                  fontSize="24px"
                >
                  <Checkbox
                    icon={<span className="t-icon-checkbox-default"></span>}
                    checked={newGasFlow.period === value}
                    checkedIcon={
                      <span className="t-icon t-icon-checkbox-checked"></span>
                    }
                    onChange={({ target: { checked } }) =>
                      setNewGasFlow((prevNewGasFlow) => ({
                        ...prevNewGasFlow,
                        period: checked ? value : "",
                      }))
                    }
                  />
                  <Typography
                    component={"p"}
                    variant="subtitle2"
                    paddingLeft="0.5rem"
                    color={theme.palette.grey[700]}
                  >
                    {t(`${label}`)}
                  </Typography>
                </Box>
              ))}
            </Box>
          </FormControl>
          <FormControl>
            <FormLabel style={{ paddingBottom: ".5rem" }}>
              <Typography fontWeight={600} fontSize={"1rem"} variant="button">
                {t(`Gestiones.Nuevo caudal`)}
                <span style={{ color: "red" }}> *</span>
              </Typography>
            </FormLabel>
            <TextField
              sx={{ width: "17.3rem" }}
              autoComplete="off"
              inputProps={{
                style: { boxShadow: "none", height: "1.8rem" },
              }}
              InputProps={{
                fullWidth: true,
                autoComplete: "off",
                type: "number",
                endAdornment: (
                  <InputAdornment position="end" sx={{ color: "red" }}>
                    {mesurement}
                  </InputAdornment>
                ),
              }}
              value={newGasFlow.value || ""}
              onChange={({ target: { value } }) =>
                setNewGasFlow((prevNewGasFlow) => ({
                  ...prevNewGasFlow,
                  value,
                }))
              }
              placeholder={t(`Gestiones.Introduce nuevo caudal`)}
            />
          </FormControl>
        </Stack>
      </Stack>
      <Box component="div" paddingBottom={{ xs: "2rem", md: "3.5rem" }}>
        <Typography component="h3" variant="h3" paddingBottom="1.5rem">
          {t("Gestiones.Día de aplicación")}
        </Typography>
        <RadioGroup
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "1.5rem",
            paddingBottom: "1.5rem",
          }}
          className="powers-radio"
        >
          {appliedDayData.map(({ id, label, value }) => (
            <FormControlLabel
              key={id}
              value={value}
              label={t(`Gestiones.${label}`)}
              onChange={() => setCheckBoxRadioValue(value)}
              control={<Radio disableRipple />}
            />
          ))}
        </RadioGroup>
        <FormControl sx={{ gap: "0.5rem" }}>
          <FormLabel htmlFor="dates">
            <Typography fontWeight={600} variant="button">
              {t(`Gestiones.Fecha de aplicación`)}
              <span style={{ color: "red" }}> *</span>
            </Typography>
          </FormLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DatePicker
              disablePast
              onChange={setAppliedDay}
              disabled={checkBoxRadioValue !== "selectDate"}
              value={appliedDay}
              slotProps={{
                textField: {
                  InputProps: {
                    placeholder: t("Seleccionar"),
                    sx: {},
                    startAdornment: appliedDay && (
                      <IconButton
                        sx={{ position: "absolute", right: "2rem" }}
                        onClick={() => setAppliedDay(null)}
                      >
                        <span className="t-icon-close" />
                      </IconButton>
                    ),
                  },
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Box>
      <Box component="div" paddingBottom={{ xs: "2rem", md: "3.5rem" }}>
        <Typography component="h3" variant="h3" paddingBottom="1.5rem">
          {t("Gestiones.Anexo")}
        </Typography>
        <Typography component="p" variant="body1">
          {t("Gestiones.Opcionalmente puede subir cualquier tipo de boletín")}
        </Typography>
        <ManagementUploadFile
          onFileUpload={(id, file) => {
            setFile(file);
          }}
        />
      </Box>
      <Box component="div" paddingBottom={{ xs: "2rem", md: "3.5rem" }}>
        <Typography component="h3" variant="h3" paddingBottom="1.5rem">
          {t("Gestiones.Nota")}
        </Typography>
        <Typography component="p" variant="body1" paddingBottom="1.5rem">
          {t("Gestiones.Opcionalmente puede dejarnos un mensaje")}
        </Typography>
        <FormControl
          sx={{
            display: "flex",
            gap: "1rem",
          }}
        >
          <FormLabel required sx={{ display: "flex", direction: "column" }}>
            <Typography component={"p"}>
              <Typography component={"span"} fontWeight={600}>
                {t("Gestiones.Mensaje")}
              </Typography>
              {` - ${t("Opcional")}`}
            </Typography>
          </FormLabel>
          <TextField
            multiline
            rows={10}
            onChange={({ target: { value } }) => setNotes(value)}
          />
        </FormControl>
      </Box>
      <Box
        component="div"
        display={"flex"}
        alignItems={"flex-start"}
        gap={"0.5rem"}
        paddingBottom={{ xs: "2rem", md: "3.5rem" }}
      >
        <Checkbox
          sx={{ fontSize: "24px" }}
          onChange={(event) => {
            setIsConsentAccepted(event.target.checked);
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
          icon={<span className="t-icon-checkbox-default"></span>}
          checkedIcon={<span className="t-icon t-icon-checkbox-checked"></span>}
        />
        <Typography component="p" variant="body1">
          {t(
            "Gestiones.Doy mi consentimiento para que se solicite una cambio en el caudal diario (Qd) en el suministro seleccionado."
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          gap: "1rem",
          marginY: "1.5rem",
          flexWrap: "wrap",
        }}
      >
        <ButtonElement
          disabled={isDisabled}
          onClick={(event) => {
            event.preventDefault();
            handleSubmit(
              formatUpdateGasFlowRequestBody(
                checkBoxRadioValue,
                appliedDay?.$d,
                newGasFlow.period,
                newGasFlow.value,
                notes
              )
            );
          }}
        >
          {t("Gestiones.Solicitar modificación de caudal")}
        </ButtonElement>
        <ButtonElement type="button" onClick={openModal} secondary>
          {t("Cancelar")}
        </ButtonElement>
      </Box>
      <ManagementsCancelProcess open={isModalOpen} handleClose={closeModal} />
    </form>
  );
};

export default ManagementsUpdateNewGasFlow;
